import * as React from 'react';
import type { SVGProps } from 'react';

const SvgParkingMarkerInactive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 58 58"
    {...props}
  >
    <g filter="url(#parking-marker-inactive_svg__a)">
      <mask
        id="parking-marker-inactive_svg__b"
        width={26}
        height={26}
        x={16}
        y={14}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M16 14h26v26H16z" />
        <path d="M17 27c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12-12-5.373-12-12" />
      </mask>
      <path
        fill="#fff"
        d="M17 27c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12-12-5.373-12-12"
        shapeRendering="crispEdges"
      />
      <path
        fill="#5F59FF"
        d="M29 39v-1c-6.075 0-11-4.925-11-11h-2c0 7.18 5.82 13 13 13zm12-12h-1c0 6.075-4.925 11-11 11v2c7.18 0 13-5.82 13-13zM29 15v1c6.075 0 11 4.925 11 11h2c0-7.18-5.82-13-13-13zm0 0v-1c-7.18 0-13 5.82-13 13h2c0-6.075 4.925-11 11-11z"
        mask="url(#parking-marker-inactive_svg__b)"
      />
      <path
        fill="#5F59FF"
        d="M26.956 32.4v-3.58h2.715c1.944 0 3.379-1.45 3.379-3.625 0-2.16-1.435-3.595-3.379-3.595H24.95v10.8zm0-8.871h2.622c.818 0 1.466.648 1.466 1.681 0 1.019-.648 1.682-1.466 1.682h-2.622z"
      />
    </g>
    <defs>
      <filter
        id="parking-marker-inactive_svg__a"
        width={58}
        height={58}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_15_9876" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_15_9876" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default SvgParkingMarkerInactive;
